exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bf-input-wrapper[data-v-cd1626f2]{display:inline-flex;align-items:center;font-size:14px}.bf-input-wrapper[data-v-cd1626f2]>:not(last-child){margin-right:.4em}.bf-input-wrapper>input[data-v-cd1626f2]{height:32px;border:1px solid #999;border-radius:4px;padding:0 8px;font-size:inherit}.bf-input-wrapper>input[data-v-cd1626f2]:hover{border-color:#666}.bf-input-wrapper>input[data-v-cd1626f2]:focus{outline:none;box-shadow:inset 0 1px 3px rgba(0,0,0,.5)}.bf-input-wrapper>input[disabled][data-v-cd1626f2]{border-color:#bbb;color:#bbb;cursor:not-allowed}.bf-input-wrapper.error>input[data-v-cd1626f2]{border-color:#f1453d}.bf-input-wrapper .error-icon[data-v-cd1626f2]{fill:#f1453d}.bf-input-wrapper .error-msg[data-v-cd1626f2]{color:#f1453d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cd1626f2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/input/bf-input.vue
// module id = 53
// module chunks = 0